import React from "react";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import notfoundIcon from "../../../../assets/images/notfound.png";

import "./not-found.m.css";

const NotFoundPage = () => {
  return (
    <div styleName="wrapper" className="container">
      <img styleName="image" src={assetify(notfoundIcon)} alt="Not Found" />
      <div styleName="content">
        <h1 styleName="status">404</h1>
        <div styleName="status-message1">Oops.. Page not found !</div>
        <p styleName="status-message2">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </p>
        <div>
          <Link href={`/`} styleName="button">
            Take me to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage ;
